import { render, staticRenderFns } from "./SalesStatus.vue?vue&type=template&id=13da410a&scoped=true"
import script from "./SalesStatus.vue?vue&type=script&lang=ts"
export * from "./SalesStatus.vue?vue&type=script&lang=ts"
import style0 from "./SalesStatus.vue?vue&type=style&index=0&id=13da410a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13da410a",
  null
  
)

export default component.exports